import SearchResultsCard from './components/searchResultCard/SearchResultsCard';

const IntegratedSearch = () => (
  <>
    <SearchResultsCard
      candidateId=""
      isDownloaded={true}
      title="Ayesha Tasneem"
      name="Ayesha Tasneem"
      skills={['java']}
      onViewCvClick={() => {
        return new Promise(() => {});
      }}
      showRelevance={true}
      relevance={'98%'}
      dateResumeLastUpdated={'2023-12-08T20:02:48.000Z'}
    />
  </>
);

export default IntegratedSearch;
